module.exports = "<app-jogo-da-velha></app-jogo-da-velha>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/main/main.component.html
// module id = ./src/app/pages/main/main.component.html
// module chunks = main